import { TableCell, TableRow } from '@/common/ui/table'
import { useSortable } from '@dnd-kit/sortable'
import { CSS } from '@dnd-kit/utilities'
import { Row, flexRender } from '@tanstack/react-table'
import { GetGameTypeTableData } from '@/modules/game/type'

interface SortableRowProps {
	row: Row<GetGameTypeTableData>
}

export function SortableRow({ row }: SortableRowProps) {
	const {
		attributes,
		listeners,
		transform,
		transition,
		setNodeRef,
		isDragging,
	} = useSortable({
		id: row.original.id,
	})

	const style = {
		transform: CSS.Transform.toString(transform),
		transition,
	}

	return (
		<TableRow
			ref={setNodeRef}
			style={style}
			className={isDragging ? 'opacity-50' : ''}
			data-state={row.getIsSelected() && 'selected'}
			{...attributes}
		>
			{row.getVisibleCells().map((cell, index) => (
				<TableCell key={cell.id} {...(index === 0 ? listeners : {})}>
					{flexRender(cell.column.columnDef.cell, cell.getContext())}
				</TableCell>
			))}
		</TableRow>
	)
}
